<template>
    <div v-cloak class="container bg-fff">
        <div class="Survey-detail pa-20 ma-b-40">
            <h1 class="t-center">
                {{ detail.Title }}
            </h1>
            <div v-if="detail.Question">
                <div v-for="(item, index) in detail.Question"
                     :key="index"
                     class="ma-t-10"
                     :id="'item' + index">
                    <div>
                        {{ index + 1 }}.{{ item.Title }}
                        {{ item.Type == 1 || item.Type == 2 || item.IsRequired ? "(" : "" }}
                        {{ item.Type == 1 ? "单选" : item.Type == 2 ? "多选" : "" }}
                        {{ item.IsRequired ? " 必填" : "" }}
                        {{ item.Type == 1 || item.Type == 2 || item.IsRequired ? ")" : "" }}
                    </div>
                    <div>
                        <!-- 选择题 -->
                        <div v-if="item.Type == 1 || item.Type == 2" class="flex f-wrap">
                            <div v-for="(it, i) in item.Item" :key="i">
                                <div class="ma-r-40 pa-tb-10 c-666 c-pointer w-s-pre"
                                     :class="item.AnswerId.includes(it.Id) ? 'active' : ''">
                                    {{ String.fromCharCode(i + 65) }} . {{ it.Item }}
                                </div>
                            </div>
                        </div>
                        <!-- 填空题目 -->
                        <div v-if="item.Type == 3 || item.Type == 4"
                             class="pa-tb-10 answer-text">
                            {{ item.AnswerText ? item.AnswerText : "【未填写答案】" }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" spaced>
    /* 大屏 宽度大于768 */
    @media (min-width: 768px) {
        .w-s-pre {
            white-space: pre;
        }

        .answer-text {
            white-space: pre-line;
            margin-top: 10px;
            background: #f6f7fb;
            padding: 5px 10px;
        }

        .active {
            font-weight: bold;
            color: #000;
        }

        .c-666 {
            color: #666;
        }

        .Survey-detail {
            box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
            background: #ffffff;
        }

        .btn-submit {
            padding: 20px 60px;
            background: #fb004d;
            color: #fff;
            display: inline-block;
            border-radius: 6px;
            cursor: pointer;
        }
    }
</style>
<script>
    import { getSurveyAnswer } from "../api.js";
    var _this;
    export default {
        name: "Survey-detail",
        components: {},
        data() {
            return {
                answerId: 0, //已提交的回答id
                detail: {}, //已经提交的答案
            };
        },

        created() {
            _this = this;
            _this.init()
        },
        watch: {
            $route(to) {
                if (to.name == "Survey-detail-my") {
                    this.init();
                }
            },
        },
        methods: {
            init() {
                //如果从个人中心来
                _this.answerId = _this.$route.query.answerId || _this.answerId;
                if (_this.answerId != 0) {
                    getSurveyAnswer({
                        id: _this.answerId,
                    }).then((res) => {
                        _this.detail = res.data.Data;
                    });
                }
            },
            //点击滚动到制定位置
            scrolls(id) {
                this.$el.querySelector(`#${id}`).scrollIntoView({
                    behavior: "smooth", // 平滑过渡
                    block: "center", //区域中间
                });
            },
        },
    };
</script>


